import { render, staticRenderFns } from "./notes.vue?vue&type=template&id=0032d5b1&scoped=true"
import script from "./notes.vue?vue&type=script&lang=js"
export * from "./notes.vue?vue&type=script&lang=js"
import style0 from "./notes.vue?vue&type=style&index=0&id=0032d5b1&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0032d5b1",
  null
  
)

export default component.exports